(function ($) {
  $(document).ready(function () {
    const $moveToEnd = $('.main-menu > div > .menu > .move-to-end')

    $moveToEnd.first().addClass('add-spacing')
  })

  $(document).on('click', '.main-menu > div > .menu > .menu-item.menu-item-has-children > a', function (e) {
    if (window.innerWidth > 1240) {
      return
    }

    e.preventDefault()

    const $thisMenuItem = $(this).parent()
    const isOpen = $thisMenuItem.hasClass('open-item')
    if (!isOpen) {
      $('.main-menu > div > .menu > .menu-item').addClass('hide-item')
      $('.main-menu > div > .menu > .menu-item a.elementor-button').parent().removeClass('hide-item')
      $thisMenuItem.addClass('open-item')
      $thisMenuItem.removeClass('hide-item')
      $thisMenuItem.find('.sub-menu').addClass('show-item')
    } else {
      $('.main-menu > div > .menu > .menu-item').removeClass('hide-item')
      $thisMenuItem.removeClass('open-item')
      $thisMenuItem.find('.sub-menu').removeClass('show-item')
    }

    return false
  })
})(jQuery)
